import type { SearchConfig } from './../../../types/shopConfig'

export const getNoveltiesIndexName = (
  isMarketplace: boolean,
  searchConfig: SearchConfig['algolia' | 'algoliaCompetera']
) => {
  if (!searchConfig) {
    return undefined
  }
  const { mpNoveltiesIndexName, noveltiesIndexName } = searchConfig
  if (isMarketplace && mpNoveltiesIndexName) {
    return mpNoveltiesIndexName
  }
  return noveltiesIndexName
}
